<template>
    <div id="login" class="login-container" :style="{ backgroundImage: `url(${loginBgUrl})` }" >

        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">

          <div class="title-container">
            <h2 class="title">
              <!--<el-image class="icon" :src="iconUrl"></el-image>-->
              {{title}}
            </h2>
          </div>
            <el-card>
                <el-row>
<!--                    <el-col :span="14" style=" height: 400px;padding:50px 30px;">-->
<!--                        <img style="width: 100%;" :src="url"/>-->
<!--                    </el-col>-->
                    <el-col :span="24"  style="padding:30px">
                        <div>
                            <p style="font-size:20px">欢迎登录</p >
                        </div>
                        <el-form-item prop="username">
                            <el-input placeholder="请输入登录账号" v-model="loginForm.username" name="username"
                                type="text">
                                <i slot="prefix" class="el-input__icon el-icon-user"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input placeholder="请输入密码" v-model="loginForm.password" name="password"
                                type="text" show-password>
                                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                            </el-input>
                        </el-form-item>
                        <el-row  :gutter="8">
                            <el-col :span="15">
                                <el-form-item prop="code">
                                    <el-input placeholder="请输入验证码" v-model="loginForm.code" name="code" @keyup.enter.native="handleLogin"
                                        type="text">
                                        <i slot="prefix" class="el-input__icon el-icon-key"></i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="9">
                                <div class="code" @click="refreshCode">
                                    <s-identify :fresh="flag" :contentWidth='108' @makedCode="getMakedCode"></s-identify>
                                </div>
                            </el-col>
                        </el-row>
                        <el-button :loading="loading" type="primary" style="width:100%;" @click.native.prevent="handleLogin">登录</el-button>

                      <div style="height: 10px;"></div>



                    </el-col>
                </el-row>
            </el-card>
        </el-form>
        <div class='foot'>
            <p>技术支持：{{support}}</p>
        </div>
    </div>
</template>

<script>

    import SIdentify from '@/components/Identify';
    import {support, title,loginBgUrl} from "@/common/const";

    import SM4 from 'sm-crypto';
    import { Base64 } from 'js-base64'


    export default {
        name: 'Login',
        data() {
            return {
                loginForm: {
                    username: '',
                    password: '',
                    code:''
                },
                loginRules: {
                    username: [{ required: true,message: '请输入登录账号', trigger: 'blur'}],
                    password: [{ required: true,message: '请输入密码', trigger: 'blur'}],
                    code: [{ required: true,message: '请输入验证码', trigger: 'blur'}],
                },

                url:require('./img/left.jpg'),
                //iconUrl:require('@/assets/icon.png'),

                loading: false,
                passwordType: 'password',
                redirect: undefined,
                cardStyle:'{padding: 0px;}',
                flag: true, //该值变化，就会触发刷新
                code:'',


              // title : "银秋-社区居家养老系统",
              // support:'合肥银秋科技有限公司',
              title:title,
              support:support,
              loginBgUrl:loginBgUrl,

            }
        },
        components:{
            SIdentify
        },
      created(){

      },
        mounted(){
            this.flag = !this.flag;
        },
        watch: {
            $route: {
                handler: function(route) {
                    this.redirect = route.query && route.query.redirect
                },
                immediate: true
            }
        },
        methods: {

          //将key加密并返回16进制
          changeKey(key) {
            const encodeBase64 = Base64.encode(key) //base64加密
            const hex = this.base64ToHex(encodeBase64)
            return hex
          },
          base64ToHex(base64) {
            const bytes = window.atob(base64)
            let hex = ''
            for (let i = 0; i < bytes.length; i++) {
              const byte = bytes.charCodeAt(i).toString(16)
              hex += byte.padStart(2, '0')
            }
            return hex
          },
          dd(){

            let key2 = this.changeKey('1234567890abcdef')
            let iv2 = this.changeKey('1234567890abcdef')


            let ss = SM4.sm4.encrypt('123',key2);
            console.log(ss);
            console.log(1111);

            let ss2 = SM4.sm4.decrypt(ss,key2);
            console.log(ss2);
            console.log(222);


            //const key = SM4.utils.hexStr2Bytes('1234567890abcdef'); // 16字节的密钥，十六进制表示
            //const iv = SM4.utils.hexStr2Bytes('abcdef9876543210'); // 16字节的初始向量，十六进制表示
            //const encrypted = SM4.ecbEncrypt('1234567', key); // 使用ECB模式加密（你也可以使用CBC模式）
            //this.cipherText = SM4.utils.bytes2HexStr(encrypted); // 将加密后的字节转换为十六进制字符串


          },


            showPwd() {
                if (this.passwordType === 'password') {
                    this.passwordType = ''
                } else {
                    this.passwordType = 'password'
                }
                this.$nextTick(() => {
                    this.$refs.password.focus()
                })
            },
            refreshCode() {
                this.flag = !this.flag;
            },
            getMakedCode(code) {
                this.code = code;
            },
            handleLogin() {

              //this.dd();

                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        if(this.loginForm.code.toLowerCase()!=this.code.toLowerCase()){
                            this.$message.info('验证码错误')
                            this.flag = !this.flag;
                            this.loading = false
                            return
                        }
                        this.loading = true
                        this.$emit('handleLogin',this.loginForm)
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }
        }
    }

</script>

<style lang="scss" scoped>
    $bg:#2d3a4b;
    $dark_gray:#889aa4;
    $light_gray:#eee;

    .login-container {
        min-height: 100%;
        width: 100%;
        background-color: $bg;
        background-image: url(./img/bg.jpg);
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        .foot{
            position: fixed;
            color: white;
            text-align: center;
            width: 100%;
            top: 90vh;
        }
        .icon{
            height: 65px;
            width: 60px;
            margin-right: 10px;
            margin-right: 20px;
        }
        .el-card{
            border-radius:10px;
            margin-top: 2vh;
            border: 0;
            /deep/ .el-card__body{
                padding: 0;
            }
        }
        .login-form {
            position: relative;
            width:400px;
            max-width: 100%;
            padding: 15vh 35px 0;
            margin: 0 auto;
            overflow: hidden;
        }

        .tips {
            font-size: 14px;
            color: #fff;
            margin-bottom: 10px;

            span {
                &:first-of-type {
                    margin-right: 16px;
                }
            }
        }

        .svg-container {
            padding: 6px 5px 6px 15px;
            color: $dark_gray;
            vertical-align: middle;
            width: 30px;
            display: inline-block;
        }

      .title-container {
        position: relative;

        .title {
          font-size: 33px;
          color: $light_gray;
          margin: 0px auto 0px auto;
          text-align: center;
          font-weight: bold;
        }
      }
        .code{
            padding: 0 5px;
        }

        .thirdparty-button {
            position: absolute;
            right: 0;
            bottom: 6px;
        }

        @media only screen and (max-width: 470px) {
            .thirdparty-button {
                display: none;
            }
        }
    }
</style>
